import React, { useMemo } from "react";
import { useOrganization } from "../../context/OrganizationContext";
import { usePermissions } from "../../hooks/usePermissions";
import {
  getAppDesktopNavActiveId,
  getVisibleAppDesktopNavItems,
} from "../../helpers/appDesktopNav";
import { DesktopSidebar } from "./DesktopSidebar";
import { DesktopNavProvider } from "./DesktopNavContext";

function initialsOf(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return `${parts[0][0]}${parts.length > 1 ? parts[parts.length - 1][0] : ""}`.toUpperCase();
}

export function AppDesktopShell({
  enabled,
  screen,
  onNavigate,
  userName,
  onOpenSettings,
  children,
}) {
  const { can, actor, orgPolicies } = usePermissions();
  const { getSetting } = useOrganization();
  const orgName = getSetting("organization.name", "");

  const sections = useMemo(
    () => getVisibleAppDesktopNavItems(can, actor, orgPolicies),
    [can, actor, orgPolicies],
  );

  const activeId = getAppDesktopNavActiveId(screen);
  const parentLabel = useMemo(
    () => sections.find((section) => section.id === activeId)?.label || "Dashboard",
    [sections, activeId],
  );
  const navValue = useMemo(() => ({ parentLabel, activeId }), [parentLabel, activeId]);

  if (!enabled) {
    return children;
  }

  return (
    <div className="cp-desktop-shell">
      <DesktopSidebar
        sections={sections}
        activeSectionId={activeId}
        onSelectSection={onNavigate}
        orgName={orgName}
        ariaLabel="CrewPilot"
        leadItemId="kpi_dashboard"
      />
      <div className="cp-desktop-shell-main">
        {screen !== "kpi_dashboard" && screen !== "user_preferences" && onOpenSettings ? (
          <div className="cp-desktop-topbar">
            <button
              type="button"
              className="cp-desktop-topbar__avatar"
              aria-label="Settings"
              title="Settings"
              onClick={onOpenSettings}
            >
              {initialsOf(userName)}
            </button>
          </div>
        ) : null}
        <DesktopNavProvider value={navValue}>{children}</DesktopNavProvider>
      </div>
    </div>
  );
}
